const CircleIcon = ({ strokeColor = '#808080' }) => {
  return (
    <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 795.1 795.1">
      <g id="Circles">
        <circle id="Grey_Bkg" data-name="Grey Bkg" cx="397.55" cy="397.55" r="388.66" fill="#4d4d4d" />
        <circle 
          id="Grey" 
          cx="397.55" 
          cy="397.55" 
          r="372.55" 
          fill="none" 
          stroke={strokeColor} 
          strokeWidth="50px" 
          strokeMiterlimit="10" 
        />
        <circle 
          id="White_Inner" 
          data-name="White Inner" 
          cx="397.55" 
          cy="397.55" 
          r="343.4" 
          fill="none" 
          stroke="#fff" 
          strokeWidth="20px" 
          strokeMiterlimit="10" 
        />
      </g>
      <g id="Shapes">
        <g id="Circle">
          <path 
            fill="#fcfcfc" 
            d="M428.63,185.5c82.29,15.93,139.37,61.93,168.72,139.68,45.93,121.67-30.46,257.76-157.4,282.45-115.63,22.49-227.39-50.26-251.18-165.88-23.96-116.45,50.58-228.82,162.37-253.44,25.5-5.61,50.99-6.23,77.49-2.81M580.85,387.08c-1.45-10.39-2.16-20.95-4.48-31.15-16.3-71.49-77.18-131.92-156.39-141.28-56.79-6.71-106.63,8.72-147.96,47.97-38.42,36.48-57.07,82.28-57.57,135.34-.44,46.3,14.03,87.4,45.11,121.67,44.87,49.48,101.08,69.24,167.27,60,46.7-6.51,84.37-29.27,113.66-65.66,29.32-36.43,42.54-78.44,40.36-126.9h0Z"
          />
        </g>
      </g>
    </svg>
  );
};

export default CircleIcon;